// extracted by mini-css-extract-plugin
export default {"root":"FucManage_root__crV6R"};